import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import App from './App';
import Settings from './services/settings.service';
import { initializeApp } from 'firebase/app';
import { analytics, performance } from 'firebase';
import TagManager from 'react-gtm-module'


if(Settings.gtm_idx) {
    const tagManagerArgs = {
        gtmId: Settings.gtm_id || ""
    }
    TagManager.initialize(tagManagerArgs)
}

// firebase analytics for KW
if (Settings.get("version") === "_kuwait" && Settings?.firebase_analytics_configs) {
    const app = initializeApp(Settings.firebase_analytics_configs);
    analytics(app);
    performance(app);
}
ReactDOM.render(<App />, document.getElementById('root'));